export default __webpack_public_path__ + "static/media/process_2.46f8ba5e.svg";